/**
 * 
 * @param {String} str //需要处理的字符串
 * @param {Array} start 需要截取的开头
 * @param {Array} end 
 * @returns 
 */
// 截取start与end 之间的字符串
export const InterceptMiddle = (str, start, end) => {
    let newstr = setStart(str, start)
    // console.log('newstr :>> ', newstr);
    newstr = setEnd(newstr, end)
    // console.log('newstr :>> ', newstr);
    return newstr
}


const setStart = (str, start) => {
    if (start.length == 0) {
        return str
    }
    let newArr = []
    for(let i in start) {
        if (str.indexOf(start[i]) != -1) {
            newArr.push(str.indexOf(start[i]) + start[i].length - 1)
        }
    }
    // console.log('newArr :>> ', newArr);
    if (newArr.length > 0) {
        let minIndex = Math.min(...newArr)
        return str.slice(minIndex + str[minIndex].length, str.length)
    } else {
        return str
    }
}

const setEnd = (str, end) => {
    if (end.length == 0 || !str) {
        return str
    }
    let newArr = []
    for(let i in end) {
        // console.log('str :>> ', str);
        if (str.indexOf(end[i]) != -1) {
            newArr.push(str.indexOf(end[i]))
        }
    }
    if (newArr.length > 0) {
        let minIndex = Math.min(...newArr)
        return str.slice(0, minIndex)
    } else {
        return str
    }
}